module.exports = __webpack_public_path__ + "img/star_heart.df7c78c2.png";